import { render } from "./AugVegas.vue?vue&type=template&id=5f80f19e"
import script from "./AugVegas.vue?vue&type=script&lang=js"
export * from "./AugVegas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__